module.exports = __webpack_public_path__ + "static/media/ostbelgien.431bbca4.png";